import { Link } from "react-router-dom";
import logo from "../../../assets/images/svg/Yantr-ai-website-logo-w.svg";

const Footer = () => {
  interface nav {
    title?: string;
    to?: any;
    id?: string;
  }
  const modules: nav[] = [
    {
      title: "Capacity Planning",
      to: "/capacity-planning",
      id: "1",
    },
    {
      title: "Strategic Planning",
      to: "/strategic-planning",
      id: "2",
    },
    {
      title: "Operational Planning",
      to: "/operational-planning",
      id: "3",
    },
    {
      title: "Jeopardy Planning",
      to: "/jeopardy-management",
      id: "4",
    },
    {
      title: "Route Planning",
      to: "/route-mapping",
      id: "5",
    },
    {
      title: "Scenario Modelling",
      to: "/scenario-modelling",
      id: "6",
    },
  ];
  /*
    {
      title: "Manufacturing",
      to: "/manufacturing",
      id: "2"
    },

    */
  const industries: nav[] = [
    {
      title: "Telecom",
      to: "/telecom",
      id: "1",
    },
    {
      title: "Retail",
      to: "/retail",
      id: "2",
    },
    {
      title: "Health Care",
      to: "/healthcare",
      id: "3",
    },
    {
      title: "Energy and Utilities",
      to: "/energy-utilities",
      id: "4",
    },
  ];
  /*
    {
      title: "Blogs",
      to: "/resources",
      id: "2"
    },
    {
      title: "Videos",
      to: "/resources",
      id: "3"
    },
    {
      title: "White Papers",
      to: "/resources",
      id: "4"
    },
*/
  const resources: nav[] = [
    {
      title: "Why Yantr.ai",
      to: "/why-yantr-ai",
      id: "1",
    },
    {
      title: "About Us",
      to: "/about-us",
      id: "5",
    },
    {
      title: "Contact Us",
      to: "/contact-us",
      id: "6",
    },
    {
      title: "Privacy Policy",
      to: "/privacy-policy",
      id: "7",
    },
    {
      title: "Cookie Preferences",
      to: "/cookies-policy",
      id: "8",
    },
  ];

  return (
    <>
      <footer className="footer">
        <div className="container py-40">
          <div className="row text-white-color">
            {/* Icon and social network */}
            <div className="col-md-4">
              <img src={logo} className="wx-214 hx-67 logo-footer" alt="logo" />
              <ul className="list-unstyled py-10">
                <li className="py-10 d-flex align-items-center flex-gap-15">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                  <div className="text-color-success text-align-left font-family-roboto font-16 fonts-400 line-30 word-break footer-subhead">
                    Yantrai.CoreTeam@TechMahindra.com
                  </div>
                </li>{" "}
                <Link
                  className="text-white-color"
                  to={"https://in.linkedin.com/company/tech-mahindra"}
                  target="_blank"
                >
                  <li className="py-10  d-flex align-items-center flex-gap-15">
                    <i className="fa-brands fa-linkedin"></i>{" "}
                    <div className="text-color-success text-align-left font-family-roboto font-16 fonts-400 line-30 footer-subhead">
                      LinkedIn
                    </div>
                  </li>
                </Link>
                <li className="py-10 d-flex align-items-center flex-gap-5">
                  <span className="text-color-success text-align-left font-family-roboto font-16 fonts-400 line-30 footer-subhead">
                    &copy; {new Date().getFullYear()}, Techmahindra Ltd. All
                    Rights Reserved
                  </span>
                </li>
              </ul>
            </div>
            {/* Modules  */}
            <div className="col-md-3">
              <p className="text-white-color font-family-roboto line-28 font-24 fonts-800 footer-head">
                Modules
              </p>
              <ul className="list-unstyled py-10">
                {modules.map((val) => (
                  <li key={val.id} className="py-8">
                    <Link
                      to={val.to}
                      className="footer-text-color d-flex align-items-center font-family-roboto flex-gap-10 font-16 fonts-400 line-20 footer-subhead"
                    >
                      <i style={{ fontSize: "3px" }} className="fa">
                        &#xf111;
                      </i>
                      {val.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* Industries */}
            <div className="col-md-3">
              <p className="text-white-color font-24 font-family-roboto line-28 fonts-800 footer-head">
                Industries
              </p>
              <ul className="list-unstyled py-10">
                {industries.map((val) => (
                  <li key={val.id} className="py-8">
                    <Link
                      to={val.to}
                      className="footer-text-color font-family-roboto d-flex align-items-center flex-gap-10 font-16 fonts-400 line-20 footer-subhead"
                    >
                      <i style={{ fontSize: "3px" }} className="fa">
                        &#xf111;
                      </i>
                      {val.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* Resources */}
            <div className="col-md-2">
              <p className="text-white-color font-24 fonts-800 font-family-roboto line-28 footer-head">
                Resources
              </p>
              <ul className="py-10">
                {resources.map((val) => (
                  <li className="py-8" key={val.id}>
                    <Link
                      to={val.to}
                      className="footer-text-color d-flex font-family-roboto align-items-center flex-gap-10 font-16 fonts-400 line-20 footer-subhead"
                    >
                      <i style={{ fontSize: "3px" }} className="fa">
                        &#xf111;
                      </i>
                      {val.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export { Footer };
